export const EVALUATION_FORMS_ADMIN_PAGE = () => `/evalaution-forms-admin-page`;
